import { render } from "./Window.vue?vue&type=template&id=3c923779&scoped=true&ts=true"
import script from "./Window.vue?vue&type=script&lang=ts"
export * from "./Window.vue?vue&type=script&lang=ts"

import "./Window.vue?vue&type=style&index=0&id=3c923779&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c923779"]])

export default __exports__